import {ENV} from '../index'

export const v999TokenTesters = [
  'shafiqruet@gmail.com',
  'thorben.otten@gmail.com',
  'it@karatbars.com',
]

export const kbcTokenTesters =
  ENV === 'development'
    ? ['shafiqruet@gmail.com', 'sales@minebase.io', 'contact@minebase.io']
    : ['sales@minebase.io']

export const testers =
  ENV === 'development'
    ? ['arafat.karatbars@gmail.com', 'shafiqruet@gmail.com']
    : ['shafiqul.islam@karatbars.com']
